module.exports = __webpack_public_path__ + "static/img/arduino_uno-2.e561c72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/arduino_uno-2.svg
// module id = t3XP
// module chunks = 0